import CustomFieldManager from "../../Manager/CustomFieldManager";
import { getLocalisedText } from "../../Translate/LanguageManager";
import { getDateString, getTitleCase } from "../../Utilities/Utility";
import DataParser from "../DataParser";
import LineItemsParser from "../LineItemsParser";
import TenantParser from "../TenantParser";

export default class WorkOrderParser {
  static parseData(dataFromAPI, templateDataToReturn) {
    //custom field
    let customFields = this.getWorkOrderResponse(dataFromAPI)
      ? this.getWorkOrderResponse(dataFromAPI).productCustomField
        ? this.getWorkOrderResponse(dataFromAPI).productCustomField
        : []
      : [];
    templateDataToReturn.customFields = customFields;
    if (customFields.length > 0) {
      customFields.forEach((element) => {
        element.module = "product";
      });
    }

    let workOrderCustomField =
      this.getWorkOrderResponse(dataFromAPI)?.customField ?? [];
    if (workOrderCustomField.length > 0) {
      workOrderCustomField.forEach((element) => {
        element.module = "work-order";
      });
      templateDataToReturn.customFields = [
        ...workOrderCustomField,
        ...customFields,
      ];
    }
    CustomFieldManager.setCustomFields(templateDataToReturn.customFields);
    templateDataToReturn =
      DataParser.assignCustomFieldValue(templateDataToReturn);

    //ref number
    templateDataToReturn.refNumber = this.getWorkOrderResponse(dataFromAPI)
      ? this.getWorkOrderResponse(dataFromAPI).documentSequenceCode
      : "";

    //comments (memo)
    templateDataToReturn.notes =
      this.getWorkOrderResponse(dataFromAPI)?.memo ?? "";

    //link document type
    templateDataToReturn.linkDocumentType = undefined;
    templateDataToReturn.linkDocumentNumber = undefined;
    var parentWorkOrderSeqCode = this.getWorkOrderResponse(dataFromAPI)
      ? this.getWorkOrderResponse(dataFromAPI).parentWorkOrderSeqCode
      : undefined;
    if (
      parentWorkOrderSeqCode !== undefined &&
      parentWorkOrderSeqCode !== null
    ) {
      // templateDataToReturn.linkDocumentType = 'parent_work_order'
      templateDataToReturn.parentWorkOrder = parentWorkOrderSeqCode;
      templateDataToReturn.linkDocumentType = getLocalisedText("work_order");
    }

    templateDataToReturn.linkDocumentType =
      templateDataToReturn.linkDocumentType ?? "";
    var workOrderSourceDetails = this.getWorkOrderResponse(dataFromAPI)
      ? this.getWorkOrderResponse(dataFromAPI).workOrderSourceDetails
      : undefined;
    if (
      workOrderSourceDetails !== undefined &&
      workOrderSourceDetails !== null
    ) {
      let multiSO = "";
      if (workOrderSourceDetails.length > 0) {
        let salesOrders = workOrderSourceDetails.filter(
          (x) => x.workOrderSource === "SALES_ORDER"
        );

        if (salesOrders && salesOrders !== null) {
          if (salesOrders.length > 0) {
            workOrderSourceDetails = salesOrders[0];

            if (salesOrders.length > 1) {
              multiSO = salesOrders
                .map((x) => x.salesOrderSequenceCode)
                .join(", ");
            }
          }
        }

        if (workOrderSourceDetails.length > 0) {
          let salesInvoice = workOrderSourceDetails.filter(
            (x) => x.workOrderSource === "SALES_INVOICE"
          );
          if (salesInvoice && salesInvoice !== null) {
            if (salesInvoice.length > 0) {
              workOrderSourceDetails = salesInvoice[0];

              if (salesInvoice.length > 1) {
                multiSO = salesInvoice
                  .map((x) => x.salesInvoiceSequenceCode)
                  .join(", ");
              }
            }
          }
        }
      }

      var salesOrderSequenceCode =
        workOrderSourceDetails.salesOrderSequenceCode;
      var workOrderSource = workOrderSourceDetails.workOrderSource;

      if (multiSO !== "") {
        templateDataToReturn.linkDocumentNumber = multiSO;
      } else if (
        salesOrderSequenceCode !== undefined &&
        salesOrderSequenceCode !== null
      ) {
        templateDataToReturn.linkDocumentNumber = salesOrderSequenceCode;
      }
      if (workOrderSource !== undefined && workOrderSource !== null) {
        if (workOrderSource.toLowerCase() === "sales_order") {
          templateDataToReturn.linkDocumentType =
            getLocalisedText("sales_order");
        } else {
          templateDataToReturn.linkDocumentType =
            getLocalisedText(workOrderSource);
        }
      }
    }

    const getFormattedDate = (dateTimeStamp, fieldName) => {
      const logDateDebug = (path, parsedDate, formattedDate) => {
        console.log("[WO Print Date Debug]", {
          fieldName,
          rawValue: dateTimeStamp,
          parsePath: path,
          parsedISO:
            parsedDate && !Number.isNaN(parsedDate.getTime())
              ? parsedDate.toISOString()
              : "",
          formattedDate,
          browserTimezoneOffset: new Date().getTimezoneOffset(),
        });
      };

      if (
        dateTimeStamp !== "" &&
        dateTimeStamp !== undefined &&
        dateTimeStamp !== null
      ) {
        if (typeof dateTimeStamp === "string") {
          const datePart = dateTimeStamp.match(/^(\d{4})-(\d{2})-(\d{2})/);
          if (datePart) {
            const parsedDate = new Date(
              Number(datePart[1]),
              Number(datePart[2]) - 1,
              Number(datePart[3])
            );
            const formattedDate = getDateString(
              parsedDate,
              templateDataToReturn.dateFormat
            );
            logDateDebug("date-only-string", parsedDate, formattedDate);
            return formattedDate;
          }
        }

        if (dateTimeStamp instanceof Date) {
          const utcDate = new Date(
            dateTimeStamp.getUTCFullYear(),
            dateTimeStamp.getUTCMonth(),
            dateTimeStamp.getUTCDate()
          );
          const formattedDate = getDateString(
            utcDate,
            templateDataToReturn.dateFormat
          );
          logDateDebug("date-instance-utc", utcDate, formattedDate);
          return formattedDate;
        }

        if (typeof dateTimeStamp === "number") {
          const parsedDate = new Date(dateTimeStamp);
          if (!Number.isNaN(parsedDate.getTime())) {
            const utcDate = new Date(
              parsedDate.getUTCFullYear(),
              parsedDate.getUTCMonth(),
              parsedDate.getUTCDate()
            );
            const formattedDate = getDateString(
              utcDate,
              templateDataToReturn.dateFormat
            );
            logDateDebug("timestamp-number-utc", utcDate, formattedDate);
            return formattedDate;
          }
        }

        const parsedDate = new Date(dateTimeStamp);
        if (!Number.isNaN(parsedDate.getTime())) {
          if (
            typeof dateTimeStamp === "string" &&
            /^(\d{4})-(\d{2})-(\d{2})T/.test(dateTimeStamp)
          ) {
            const utcDate = new Date(
              parsedDate.getUTCFullYear(),
              parsedDate.getUTCMonth(),
              parsedDate.getUTCDate()
            );
            const formattedDate = getDateString(
              utcDate,
              templateDataToReturn.dateFormat
            );
            logDateDebug("date-time-string-utc", utcDate, formattedDate);
            return formattedDate;
          }

          const formattedDate = getDateString(
            parsedDate,
            templateDataToReturn.dateFormat
          );
          logDateDebug("generic-date", parsedDate, formattedDate);
          return formattedDate;
        }

        logDateDebug("invalid-date", undefined, "");
      }
      return "";
    };

    //start date
    templateDataToReturn.date = getFormattedDate(
      this.getWorkOrderResponse(dataFromAPI)?.actualStartDate,
      "date"
    );

    templateDataToReturn.dueDate = "";
    templateDataToReturn.showDueDate = false;
    templateDataToReturn.plannedStartDate = getFormattedDate(
      this.getWorkOrderResponse(dataFromAPI)?.plannedStartDate,
      "plannedStartDate"
    );
    templateDataToReturn.plannedEndDate = getFormattedDate(
      this.getWorkOrderResponse(dataFromAPI)?.plannedEndDate,
      "plannedEndDate"
    );
    templateDataToReturn.actualStartDate = getFormattedDate(
      this.getWorkOrderResponse(dataFromAPI)?.actualStartDate,
      "actualStartDate"
    );
    templateDataToReturn.actualEndDate = getFormattedDate(
      this.getWorkOrderResponse(dataFromAPI)?.actualEndDate,
      "actualEndDate"
    );

    templateDataToReturn.deliveryDate = getFormattedDate(
      this.getWorkOrderResponse(dataFromAPI)?.deliveryDate,
      "deliveryDate"
    );

    templateDataToReturn = this.getDefaultValue(
      dataFromAPI,
      templateDataToReturn,
      "productName"
    );
    templateDataToReturn = this.getDefaultValue(
      dataFromAPI,
      templateDataToReturn,
      "productCode"
    );
    templateDataToReturn = this.getDefaultValue(
      dataFromAPI,
      templateDataToReturn,
      "productDescription"
    );
    templateDataToReturn = this.getDefaultValue(
      dataFromAPI,
      templateDataToReturn,
      "productDocSeqCode"
    );
    if (templateDataToReturn.productDocSeqCode) {
      templateDataToReturn.productCode = templateDataToReturn.productDocSeqCode;
    }
    templateDataToReturn = this.getDefaultValue(
      dataFromAPI,
      templateDataToReturn,
      "estimatedTime"
    );
    templateDataToReturn = this.getDefaultValue(
      dataFromAPI,
      templateDataToReturn,
      "actualQuantity"
    );
    templateDataToReturn = this.getDefaultValue(
      dataFromAPI,
      templateDataToReturn,
      "manufactureQuantity"
    );
    templateDataToReturn = this.getDefaultValue(
      dataFromAPI,
      templateDataToReturn,
      "status"
    );
    templateDataToReturn.woStatus = templateDataToReturn.status ?? "";
    templateDataToReturn = this.getDefaultValue(
      dataFromAPI,
      templateDataToReturn,
      "qcStatus"
    );
    templateDataToReturn = this.getDefaultValue(
      dataFromAPI,
      templateDataToReturn,
      "contactName"
    );

    templateDataToReturn.woStatus = getTitleCase(templateDataToReturn.woStatus);
    templateDataToReturn.qcStatus = getTitleCase(templateDataToReturn.qcStatus);

    templateDataToReturn.taggedBinWarehouseInfo = this.getWorkOrderResponse(
      dataFromAPI
    )
      ? this.getWorkOrderResponse(dataFromAPI).taggedBinWarehouseInfo
      : undefined;

    templateDataToReturn.customerOrderNumber = "";
    if (dataFromAPI.salesOrderCustomerOrderNumber) {
      templateDataToReturn.customerOrderNumber =
        dataFromAPI.salesOrderCustomerOrderNumber;
    }
    if (
      workOrderSourceDetails !== undefined &&
      workOrderSourceDetails !== null
    ) {
      if (
        workOrderSourceDetails.salesOrderCustomerOrderNumber !== undefined &&
        workOrderSourceDetails.salesOrderCustomerOrderNumber !== null
      ) {
        templateDataToReturn.customerOrderNumber =
          workOrderSourceDetails.salesOrderCustomerOrderNumber;
      }
    }
    //line items
    templateDataToReturn.lineItems = LineItemsParser.getWorkOrderItems(
      dataFromAPI,
      templateDataToReturn.dateFormat
    );

    //check if contains 'SCRAP' or 'COPRODUCT'
    templateDataToReturn.isContainsScrapProduct = false;
    templateDataToReturn.isContainsCoproduct = false;
    if (templateDataToReturn.lineItems.length > 0) {
      var scrapProduct = templateDataToReturn.lineItems.find(
        (x) => x.produceProductType === "SCRAP"
      );
      templateDataToReturn.isContainsScrapProduct = scrapProduct !== undefined;
      var coproductProduct = templateDataToReturn.lineItems.find(
        (x) => x.produceProductType === "COPRODUCT"
      );
      templateDataToReturn.isContainsCoproduct = coproductProduct !== undefined;
    }

    templateDataToReturn = TenantParser.parseLocationDetail(
      dataFromAPI,
      templateDataToReturn
    );

    templateDataToReturn.woSerialBatch = this.getSerialBatchForFG(dataFromAPI);
    templateDataToReturn.serialBatchNumber =
      this.getSerialBatchForFG(dataFromAPI);

    //work order barcode
    var barcodeList = [];
    if (
      dataFromAPI.jobCardResponseList !== undefined &&
      dataFromAPI.jobCardResponseList !== null
    ) {
      if (dataFromAPI.jobCardResponseList.length > 0) {
        dataFromAPI.jobCardResponseList.forEach((element, index) => {
          var item = {
            index: index,
            label: element.operationName,
            value: element.documentSequenceCode,
            instructions: element.instructions ?? "",
            status: element.status ?? "",
          };
          barcodeList.push(item);
        });
      }
    }
    templateDataToReturn.barcodeList = barcodeList;
    return templateDataToReturn;
  }

  static getSerialBatchForFG(dataFromApi) {
    return LineItemsParser.getWorkOrderSerialBatchFromWarehouseInventoryData(
      dataFromApi?.workOrderResponse?.warehouseInventoryData
    );
  }

  static getWorkOrderResponse(dataFromApi) {
    if (
      dataFromApi.workOrderResponse !== undefined &&
      dataFromApi.workOrderResponse !== null
    ) {
      return dataFromApi.workOrderResponse;
    }
    return undefined;
  }

  static getDefaultValue(dataFromAPI, templateDataToReturn, key) {
    templateDataToReturn[key] = this.getWorkOrderResponse(dataFromAPI)
      ? this.getWorkOrderResponse(dataFromAPI)[key]
      : "";
    return templateDataToReturn;
  }
}
